function createSlider() {
    new Swiper('#news .swiper-container', {
        slidesPerView: 'auto',
        spaceBetween: 16,
        freeMode: true,
        navigation: {
            prevEl: '#news .slider__arrow_prev',
            nextEl: '#news .slider__arrow_next',
            disabledClass: 'slider__arrow_disabled'
        },
        breakpoints: {
            960: {
                slidesPerView: 3,
                freeMode: false,
                allowTouchMove: false
            }
        }
    });

    new Swiper('#articles .swiper-container', {
        slidesPerView: 'auto',
        spaceBetween: 16,
        freeMode: true,
        navigation: {
            prevEl: '#articles .slider__arrow_prev',
            nextEl: '#articles .slider__arrow_next',
            disabledClass: 'slider__arrow_disabled'
        },
        breakpoints: {
            960: {
                slidesPerView: 3,
                freeMode: false,
                allowTouchMove: false
            }
        }
    });
}

createSlider();

$(document).ready(function() {
    let loadMore = true;
    $('body').on('click', '.load-more-article', function(e) {
        e.preventDefault();
        let mainBlock = $(this).parents('.news-or-articles');
        if (loadMore) {
            loadMore = false;
            $.ajax({
                url: $(this).attr('href'),
                type: 'get',
                processData: false,
                contentType: false,
                success: function(response) {
                    let block = $(response).find('#' + mainBlock.attr('id'));
                    let lists = block.find('.list li');
                    $.each(lists, function(k, item) {
                        mainBlock.find('.list').append(item);
                    });
                    let sliders = block.find('.slider__slides li');
                    $.each(sliders, function(k, item) {
                        mainBlock.find('.slider__slides').append(item);
                    });
                    let btn = block.find('.load-button');
                    if (btn.length) {
                        mainBlock
                            .find('.load-button')
                            .attr('href', btn.attr('href'));
                    } else {
                        mainBlock.find('.load-button').hide();
                    }
                }
            }).always(function() {
                loadMore = true;
            });
        }
    });
});
